import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition
} from "app/library/layout-builder";

export class SubscribeOutDefinitions extends CmsReactComponent<any> {

    static schemaName = "subscribeOut";

    static propertyDefinitions: PropertyDefinition[] = [];


}
